import { slices } from "@/constants/sliceNames";
import { createAsyncThunk } from "@reduxjs/toolkit";
import blobAxios, { downloadBlob } from "@/axios/blobDownloadAxios";
import axios from "@/axios/defaultAxios";

import { errorMessage } from "../actions/messages.actions";

/****** Download file ******/

export const requestDownloadFile = createAsyncThunk(
  `${slices.download}/requestDownloadFile`,
  async ({ endpoint, body = {}, filename = "result.zip" }, { rejectWithValue, dispatch }) => {
    try {
      const response = await blobAxios.post(endpoint, body);
      downloadBlob(response.data, filename);
      return response.data.data;
    } catch (error) {
      dispatch(errorMessage(error.response?.message ?? error.response?.data ?? error.message));
      return rejectWithValue(error.response?.message ?? error.response?.data ?? error.message);
    }
  }
);

export const requestDownloadFileStatus = {
  [requestDownloadFile.fulfilled]: (state, action) => {
    state.loading = false;
    state.total = state.downloaded = state.percentage = 0;
  },
  [requestDownloadFile.pending]: (state, action) => {
    state.loading = true;
    state.total = state.downloaded = state.percentage = 0;
  },
  [requestDownloadFile.rejected]: (state, action) => {
    state.loading = false;
    state.total = state.downloaded = state.percentage = 0;
    state.error = action.payload;
  },
};

/****** Download execution's logs ******/

export const requestDownloadExecLogs = createAsyncThunk(
  `${slices.download}/requestDownloadExecLogs`,
  async (executionId, { rejectWithValue, dispatch }) => {
    try {
      const response = await axios.get(`/appexecutions/v2/logs/${executionId}`);
      if (response.status === 200 || response.status === 201) {
        return response.data.data;
      }
      throw new Error(response.data?.error ?? response.data?.message);
    } catch (error) {
      dispatch(errorMessage(error.response?.message ?? error.response?.data ?? error.message));
      return rejectWithValue(error.response?.message ?? error.response?.data ?? error.message);
    }
  }
);

export const requestDownloadExecLogsStatus = {
  [requestDownloadExecLogs.fulfilled]: (state, action) => {
    state.loading = false;
  },
  [requestDownloadExecLogs.pending]: (state, action) => {
    state.loading = true;
  },
  [requestDownloadExecLogs.rejected]: (state, action) => {
    state.loading = false;
    state.error = action.payload;
  },
};
